import {defineStore} from 'pinia';
import {ref, nextTick} from 'vue';
import {generateUniqId} from '@/core/util/reference-utils';
import LocalStorageDecorator from '@/store/storage/local-storage-decorator';

export const useCartReferenceStore = defineStore('cartReferenceStore', () => {
    const cartReference = ref(generateUniqId());

    // This property is used to force persistence update due to an issue with Safari
    const persistenceCounter = ref(0);

    const resetData = () => {
        cartReference.value = generateUniqId();
        persistenceCounter.value = 0;
    };

    const ensureReference = () => {
        if (!cartReference.value) {
            cartReference.value = generateUniqId();
        }
        persistenceCounter.value++;
    };

    // Trigger persistence update
    nextTick(() => {
        ensureReference();
    });

    return { cartReference, resetData, ensureReference, persistenceCounter };
}, {
    persist: {
        storage: LocalStorageDecorator
    }
});
